import React from 'react'
import '../utils/index.css'
import { IPropsTickets } from '../utils/interfaceTickets'
import PrincipalInfoTicket from './PrincipalInfoTicket'
import InfoProduct from './InfoProduct'
import InfoClientTicket from './InfoClientTicket'
import PaymentMeans from './PaymentMeans'
import FooterCreditTicket from './FooterCreditTicket'
import HeaderCreditTickets from './HeaderCreditTickets'

const MainCreditTicketStruct = ({ data, imageRef, logoBase }: IPropsTickets) => {

    return (
        <>

            <HeaderCreditTickets data={data} imageRef={imageRef} logoBaseProp={logoBase} />

            <PrincipalInfoTicket data={data} />

            <div className='receipt__separator'></div>
            <div className='receipt__text__center text__bold'> DUPLICADO </div>
            <div className='receipt__separator'></div>

            <InfoProduct data={data} />

            <br />
            <br />

            <InfoClientTicket data={data} />

            <br />
            <br />

            <PaymentMeans data={data} />

            <br />
            <br />

            <FooterCreditTicket />
        </>
    )
}

export default MainCreditTicketStruct